import { SvgAsset } from '@ingenico/react-ui/svg-asset';
import { styled } from '@mui/material';
import type { ReactNode } from 'react';
import type { CirclesAttributes } from './temConnectionModalHeader.model';
import styles from './temConnectionModalHeader.module.scss';
import { generateBgCircles, qttBgCircles } from './temConnectionModalHeader.util';

const CircleIcon = styled(SvgAsset)<CirclesAttributes>(({ size, strokeWidth, strokeDasharray }) => ({
  width: size,
  height: size,
  strokeWidth,
  '& circle': {
    strokeDasharray: strokeDasharray.join(' '),
  },
}));

export function TemConnectionModalHeader(): ReactNode {
  return (
    <div className={styles.connectionHeaderContainer}>
      <div className={styles.circlesContainer}>
        {generateBgCircles(qttBgCircles).map(
          ({ size, translatey, strokeWidth, strokeDasharray, scale }: CirclesAttributes, _index) => (
            <CircleIcon
              image="dashed-ellipse"
              key={`circle-${size}-${translatey}`}
              scale={scale}
              size={size}
              strokeDasharray={strokeDasharray as number[] & number}
              strokeWidth={strokeWidth}
              translatey={translatey}
              {...{
                viewBox: '0 0 227 227',
                preserveAspectRatio: 'xMidYMid meet',
              }}
            />
          ),
        )}
      </div>
      <div className={styles.deviceContainer}>
        <SvgAsset image="terminal" />
      </div>
    </div>
  );
}
